import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";

import "./radioButton.scss";

const RadioButton = ({
  id,
  isInvalid = false,
  label,
  name,
  small = false,
  value,
  onBlur,
  onChange,
}) => (
  <Form.Check type="radio" id={id} className={classNames("radio-button", { "radio-button--small": small })}>
    <Form.Check.Input type="radio" name={name} isInvalid={isInvalid} value={value} onChange={onChange} onBlur={onBlur} />
    <Form.Check.Label>{label}</Form.Check.Label>
  </Form.Check>
);

RadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  isInvalid: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  small: PropTypes.bool,
  value: PropTypes.string.isRequired,
};

export default RadioButton;
